// extracted by css-extract-rspack-plugin
export default {"root":"uIgGNZiMmFMIJhcf","contacts":"BymaaFSSbjM9mVJK","contact":"cBfybIMsxagMP4zk","details":"fAK996tcAxcV_FUs","link":"dZTsgiTOFfs3XobR"};